
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/over-ons/team/[uid]",
      function () {
        return require("private-next-pages/over-ons/team/[uid].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/over-ons/team/[uid]"])
      });
    }
  